var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConsumablesHowItWorksStep3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.1665,
    y: 1.5,
    width: 37,
    height: 37,
    rx: 18.5,
    stroke: "url(#paint0_linear_2430_224193)",
    strokeOpacity: 0.2,
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M20.6228 29.2386C19.3501 29.2386 18.2166 29.0199 17.2223 28.5824C16.2336 28.1392 15.4524 27.5312 14.8785 26.7585C14.3103 25.9801 14.0177 25.0824 14.0007 24.0653H17.7166C17.7393 24.4915 17.8785 24.8665 18.1342 25.1903C18.3956 25.5085 18.7421 25.7557 19.174 25.9318C19.6058 26.108 20.0916 26.196 20.6313 26.196C21.1938 26.196 21.691 26.0966 22.1228 25.8977C22.5546 25.6989 22.8927 25.4233 23.137 25.071C23.3813 24.7187 23.5035 24.3125 23.5035 23.8523C23.5035 23.3864 23.3728 22.9744 23.1115 22.6165C22.8558 22.2528 22.4865 21.9687 22.0035 21.7642C21.5262 21.5597 20.9581 21.4574 20.299 21.4574H18.6711V18.7472H20.299C20.8558 18.7472 21.3473 18.6506 21.7734 18.4574C22.2052 18.2642 22.5404 17.9972 22.7791 17.6562C23.0177 17.3097 23.137 16.9062 23.137 16.446C23.137 16.0085 23.0319 15.625 22.8217 15.2955C22.6171 14.9602 22.3274 14.6989 21.9524 14.5114C21.5831 14.3239 21.1512 14.2301 20.6569 14.2301C20.1569 14.2301 19.6995 14.321 19.2848 14.5028C18.87 14.679 18.5376 14.9318 18.2876 15.2614C18.0376 15.5909 17.9041 15.9773 17.887 16.4205H14.3501C14.3671 15.4148 14.6541 14.5284 15.2109 13.7614C15.7677 12.9943 16.5177 12.3949 17.4609 11.9631C18.4098 11.5256 19.4808 11.3068 20.674 11.3068C21.8785 11.3068 22.9325 11.5256 23.8359 11.9631C24.7393 12.4006 25.441 12.9915 25.941 13.7358C26.4467 14.4744 26.6967 15.304 26.691 16.2244C26.6967 17.2017 26.3927 18.017 25.7791 18.6705C25.1711 19.3239 24.3785 19.7386 23.4012 19.9148V20.0511C24.6853 20.2159 25.6626 20.6619 26.3331 21.3892C27.0092 22.1108 27.3444 23.0142 27.3387 24.0994C27.3444 25.0938 27.0575 25.9773 26.4779 26.75C25.9041 27.5227 25.1115 28.1307 24.1001 28.5739C23.0887 29.017 21.9296 29.2386 20.6228 29.2386Z",
    fill: "url(#paint1_linear_2430_224193)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2430_224193",
    x1: 0.666497,
    y1: 39.9999,
    x2: 43.5218,
    y2: 36.6624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E5FF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2430_224193",
    x1: 0.666497,
    y1: 33.9999,
    x2: 43.2545,
    y2: 29.2617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E5FF4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsumablesHowItWorksStep3);
export default __webpack_public_path__ + "static/media/consumables_how_it_works_step_3.14d259bbfc9360ad2e1f775782501ba7.svg";
export { ForwardRef as ReactComponent };